import { render, staticRenderFns } from "./summary-card.vue?vue&type=template&id=4b1a96ac&scoped=true"
import script from "./summary-card.vue?vue&type=script&lang=js"
export * from "./summary-card.vue?vue&type=script&lang=js"
import style0 from "./summary-card.vue?vue&type=style&index=0&id=4b1a96ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1a96ac",
  null
  
)

export default component.exports